import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import locationUtils from 'utils/locationUtils/locationUtils';
import { Svg, Loading } from '@jg/components';
import config from 'config/config';
import matchMyMilesWhite from 'assets/svg/matchmymiles-white.svg';
import './LandingHero.scss';

const numberOfRunners = '575,000';

const LandingHero = ({ location, isLoading, isError, onCTAClick }) => (
  <div className="landing-hero">
    <div className="landing-hero__inner">
      <Svg markup={matchMyMilesWhite} alt="MATCHmyMILES" className="landing-hero__logo" />
      <p className="landing-hero__strap">Join our community of <strong>{numberOfRunners} runners</strong> matching their miles for charity</p>
      <div className="landing-hero__get-started-btn__wrapper">
        <Link
          onClick={onCTAClick}
          to={`${config.ROOT_PATH}/charity-search?guid=${location.query.guid}`}
          disabled={isError}
          className={`landing-hero__get-started-btn ${isLoading && 'inactive-link'} ${isError && 'is-disabled'}`}
        >
          {
            isLoading ? <Loading size="small" colour="white" /> : 'Get Started'
          }
        </Link>
      </div>
    </div>
  </div>
);

LandingHero.propTypes = {
  onCTAClick: PropTypes.func,
  location: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.object])),
  isError: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

LandingHero.defaultProps = {
  location: locationUtils.locationStub,
  isError: false,
  isLoading: false,
};

export default LandingHero;



// WEBPACK FOOTER //
// ./components/LandingHero/LandingHero.js